export default __webpack_public_path__ + "static/media/cross.06971f17.jpg";